/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PatchedTaskStatusUpdateRequest,
  TaskStatusArchiveRequest,
  TaskStatusCreateRequest,
  TaskStatusReorderRequest,
  TaskStatusWithCount
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type taskStatusesListResponse200 = {
  data: TaskStatusWithCount[]
  status: 200
}

export type taskStatusesListResponseSuccess = (taskStatusesListResponse200) & {
  headers: Headers;
};
;

export type taskStatusesListResponse = (taskStatusesListResponseSuccess)

export const getTaskStatusesListUrl = () => {




  return `/api/v1/task-statuses/`
}

export const taskStatusesList = async ( options?: RequestInit): Promise<taskStatusesListResponse> => {

  return customFetch<taskStatusesListResponse>(getTaskStatusesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type taskStatusesCreateResponse201 = {
  data: TaskStatusWithCount[]
  status: 201
}

export type taskStatusesCreateResponseSuccess = (taskStatusesCreateResponse201) & {
  headers: Headers;
};
;

export type taskStatusesCreateResponse = (taskStatusesCreateResponseSuccess)

export const getTaskStatusesCreateUrl = () => {




  return `/api/v1/task-statuses/`
}

export const taskStatusesCreate = async (taskStatusCreateRequest: TaskStatusCreateRequest, options?: RequestInit): Promise<taskStatusesCreateResponse> => {

  return customFetch<taskStatusesCreateResponse>(getTaskStatusesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskStatusCreateRequest)
  }
);}


export type taskStatusesPartialUpdateResponse200 = {
  data: TaskStatusWithCount[]
  status: 200
}

export type taskStatusesPartialUpdateResponseSuccess = (taskStatusesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type taskStatusesPartialUpdateResponse = (taskStatusesPartialUpdateResponseSuccess)

export const getTaskStatusesPartialUpdateUrl = (id: string,) => {




  return `/api/v1/task-statuses/${id}/`
}

export const taskStatusesPartialUpdate = async (id: string,
    patchedTaskStatusUpdateRequest?: PatchedTaskStatusUpdateRequest, options?: RequestInit): Promise<taskStatusesPartialUpdateResponse> => {

  return customFetch<taskStatusesPartialUpdateResponse>(getTaskStatusesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedTaskStatusUpdateRequest)
  }
);}


export type taskStatusesArchiveCreateResponse200 = {
  data: TaskStatusWithCount[]
  status: 200
}

export type taskStatusesArchiveCreateResponseSuccess = (taskStatusesArchiveCreateResponse200) & {
  headers: Headers;
};
;

export type taskStatusesArchiveCreateResponse = (taskStatusesArchiveCreateResponseSuccess)

export const getTaskStatusesArchiveCreateUrl = (id: string,) => {




  return `/api/v1/task-statuses/${id}/archive/`
}

export const taskStatusesArchiveCreate = async (id: string,
    taskStatusArchiveRequest?: TaskStatusArchiveRequest, options?: RequestInit): Promise<taskStatusesArchiveCreateResponse> => {

  return customFetch<taskStatusesArchiveCreateResponse>(getTaskStatusesArchiveCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskStatusArchiveRequest)
  }
);}


export type taskStatusesReorderCreateResponse200 = {
  data: TaskStatusWithCount[]
  status: 200
}

export type taskStatusesReorderCreateResponseSuccess = (taskStatusesReorderCreateResponse200) & {
  headers: Headers;
};
;

export type taskStatusesReorderCreateResponse = (taskStatusesReorderCreateResponseSuccess)

export const getTaskStatusesReorderCreateUrl = () => {




  return `/api/v1/task-statuses/reorder/`
}

export const taskStatusesReorderCreate = async (taskStatusReorderRequest: TaskStatusReorderRequest, options?: RequestInit): Promise<taskStatusesReorderCreateResponse> => {

  return customFetch<taskStatusesReorderCreateResponse>(getTaskStatusesReorderCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskStatusReorderRequest)
  }
);}


